export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_q04_a.8a40d5a4.png";